import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Spin, message, Tabs, Col, Input } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';

function AboutAddEdit() {
	const navigate = useNavigate();
	const { editAboutId } = useParams();
	const [isLoading, setIsLoading] = useState(false);
	const [form] = Form.useForm();

	const get = () => {
		if (!editAboutId) return;

		setIsLoading(true);
		axios
			.get(`/about`, { params: { _id: editAboutId } })
			.then((result) => {
				if (Array.isArray(result.data.data) && result.data.data.length) {
					const [data] = result.data.data;
					form.setFieldsValue(data);
				}
			})
			.catch(() => {})
			.finally(() => setIsLoading(false));
	};

	const onSave = () => {
		form.validateFields()
			.then((values) => {
				setIsLoading(true);
				if (editAboutId) values._id = editAboutId;

				axios({
					method: editAboutId ? 'put' : 'post',
					url: '/about',
					data: values,
				})
					.then((result) => {
						if (result.data.success) {
							message.success(result.data.message);
							navigate('/about');
						} else {
							message.error(result.data.message);
							setIsLoading(false);
						}
					})
					.catch(() => {
						message.error('Oops! Something went wrong!');
						setIsLoading(false);
					});
			})
			.catch((e) => console.log(e));
	};

	useEffect(() => {
		get();
	}, []);

	return (
		<>
			<BreadCrumb breadcrumbs={[{ link: '/', label: 'Home' }, { label: 'About' }]} />
			<Spin spinning={isLoading}>
				<div className='main-content'>
					<div className='page-header'>
						<div className='page-title'>{editAboutId ? 'Edit About' : 'Add About'}</div>
						<div className='page-title-more'>
							<Link to='/about'>
								<Button icon={<ArrowLeftOutlined />}>Back</Button>
							</Link>
							<Button icon={<SaveOutlined />} type='primary' onClick={onSave} loading={isLoading}>
								Save
							</Button>
						</div>
					</div>

					<div className='form-content'>
						<Form form={form} layout='vertical' autoComplete='off'>
							<Tabs
								defaultActiveKey='1'
								items={[
									{
										key: 'Details',
										label: 'Details',
										children: (
											<>
												<Col sm={24} md={12}>
													<Form.Item
														label='Title'
														name='title'
														rules={[
															{
																required: true,
																message: 'Title is required',
															},
														]}
													>
														<Input placeholder='Enter a Title' autoFocus />
													</Form.Item>
												</Col>

												<Col sm={24} md={12}>
													<Form.Item label='Subtitle' name='subtitle'>
														<Input placeholder='Enter a Subtitle' />
													</Form.Item>
												</Col>

												<Col sm={24} md={12}>
													<Form.Item label='Description' name='about'>
														<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} placeholder='Enter detailed About Us description' />
													</Form.Item>
												</Col>

												<Col sm={24} md={12}>
													<Form.Item label='Mission' name='mission'>
														<Input.TextArea rows={3} placeholder='Enter mission' />
													</Form.Item>
												</Col>

												<Col sm={24} md={12}>
													<Form.Item label='Vision' name='vision'>
														<Input.TextArea rows={3} placeholder='Enter vision' />
													</Form.Item>
												</Col>

												<Col sm={24} md={12}>
													<Form.Item label='Years Experience' name='yearsexperience'>
														<Input placeholder='Enter Years Experience' />
													</Form.Item>
												</Col>
											</>
										),
									},
								]}
							/>
						</Form>
					</div>
				</div>
			</Spin>
		</>
	);
}

export default AboutAddEdit;
